import React from "react";
import {
  Box,
  Grid,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const SummaryCommonComponents = ({ summaryArray = [] }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const theme = useTheme();
  const colors = [
    theme.palette.warning.main,
    theme.palette.success.main,
    theme.palette.error.main,
    theme.palette.info.main,
    theme.palette.primary.main,
  ];

  return (
    <SummaryBox isMobile={isMobile}>
      <Grid container spacing={1} alignItems="stretch" justifyContent={"stretch"}>
        {summaryArray.map((item, index) => (
          <Grid item key={index} xs={6} sm="auto">
            <ItemCard>
              <ItemHeader>
                <ColorPill
                  style={{ background: colors[index % colors.length] }}
                />
                <Typography
                  sx={{
                    fontSize: isMobile ? 10 : 14,
                    fontWeight: 500,
                    color: theme.palette.text.secondary,
                  }}
                >
                  {item.key}
                </Typography>
              </ItemHeader>

              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 16,
                  mt: 1,
                  color: colors[index % colors.length],
                }}
              >
                {item.value ?? 0}
              </Typography>
            </ItemCard>
          </Grid>
        ))}
      </Grid>
    </SummaryBox>
  );
};

export default SummaryCommonComponents;

const SummaryBox = styled(Box)(({ isMobile }) => ({
  borderRadius: "10px",
  border: "1px solid rgba(19, 115, 229, 0.12)",
  background: "rgba(39, 137, 253, 0.02)",
  padding: "8px",
  display: isMobile ? "block" : "inline-block",
  marginTop: "10px",
  width: isMobile ? "100%" : "auto",
}));

const ItemCard = styled(Box)(() => ({
  background: "#fff",
  borderRadius: 8,
  padding: "8px 10px",
  height: "100%",
  boxShadow: "0 1px 4px rgba(12,15,20,0.04)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  minWidth: 105,
  whiteSpace: "nowrap",
}));

const ItemHeader = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: 6,
}));

const ColorPill = styled(Box)(() => ({
  width: 10,
  height: 10,
  borderRadius: "50%",
  boxShadow: "0 0 0 4px rgba(0,0,0,0.02) inset",
}));